<template>
    <div class="page userPage">
        <div class="section">
            <span class="operate_edit nucfont inuc-edit" v-if="isEdit" @click="editForm"></span>

            <div class="info-wrap" :class="isEdit ? classA:classB">
                <el-form :model="formSystemData" :rules="rules" ref="formSystemData"
                         :label-width="$i18n.locale === 'zh-CN' ? '120px': '200px'"
                         class="el-form-label-top system-form">
                    <el-form-item :label="$t('system.sysName')" prop="name">
                        <el-input v-model="formSystemData.name" :placeholder="$t('tip.sysName')"
                                  :disabled="isEdit"
                                  :clearable="isEdit==false"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('system.sysEnName')" prop="enName">
                        <el-input v-model="formSystemData.enName" :placeholder="$t('tip.sysEnName')"
                                  :disabled="isEdit"
                                  :clearable="isEdit==false"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('system.sysShortName')" prop="shortName">
                        <el-input v-model="formSystemData.shortName" :placeholder="$t('tip.sysShortName')"
                                  :disabled="isEdit"
                                  :clearable="isEdit==false"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('system.sysVersion')" prop="version">
                        <el-input v-model="formSystemData.version" :placeholder="$t('tip.sysVersion')"
                                  :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item v-if="isEdit==false">
                        <el-button type="primary" @click="submitForm('formSystemData')">{{ $t('m.save') }}</el-button>
                        <el-button @click="cancelCommit('formSystemData')">{{ $t('m.cancel') }}</el-button>
                    </el-form-item>
                </el-form>

                <div class="right-logo">
                    <div class="logo-box" :class="{'inactive': isEdit}" >
                        <el-upload
                            class="avatar-uploader"
                            :action="imgUpload.api"
                            :data="imgUpload.params"
                            accept=".jpg,.jpeg,.bmp,.png"
                            name="upfile"
                            :show-file-list="false"
                            :on-success="uploadSuccess"
                            :before-upload="beforeUpload"
                            :disabled="isEdit"
                        >
                            <img v-if="formSystemData.logo" :src="formSystemData.logo" class="avatar" :title="$t('system.editSysLogo')">
                            <i class="el-icon-plus avatar-uploader-icon" :title="$t('system.editSysLogo')" v-else></i>
                            <div class="mask" v-if="!isEdit && formSystemData.logo" @click.stop="">
                                <i class="nucfont inuc-delete delete-cover" :title="$t('c.delete')"
                                   @click.stop="delImg"></i>
                            </div>
                            <!--<div class="el-upload__tip" slot="tip">{{$t('course.coverTip')}}</div>-->
                        </el-upload>
                    </div>
                    <p class="logo-txt">{{$t('system.sysLogo')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import api from '@/api';
    import {Ticket} from '@/utils';

    export default {
        data() {
            return {
                formSystemData: {
                    name: '',
                    enName: '',
                    shortName: '',
                    version: '',
                    logo: ''
                },
                isEdit: true,
                classA: '',
                classB: 'animated bounceInRight',
                rules: {
                    name: [
                        {required: true, message: this.$t('tip.sysName'), trigger: 'blur'},
                        {min: 3, max: 100, message: this.$t('rule.lengthBetween', ['3', '100']), trigger: 'blur'}
                    ],
                    enName: [
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    shortName: [
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                },

                isUploadDisable: true,
                imgUpload: {
                    api: api.fileUploadURL + '/logo',
                    params: {
                        'access_token': Ticket.get().access_token
                    },
                    show: false,
                },
                imageUrl: '',
            }
        },
        created() {
            this.fillSystemInfo(this.systemInfo);
        },
        computed: {
            ...mapGetters([
                'systemInfo',
            ]),
        },
        methods: {
            fillSystemInfo(sysInfo){
                if (!Object.keys(sysInfo).length) return;

                for (let item in sysInfo) {
                    if (this.formSystemData.hasOwnProperty(item)) {
                        this.formSystemData[item] = sysInfo[item];
                    }
                }
            },
            updateSystemInfo() {
                this.$store.dispatch('getSystemInfo');
            },
            editForm(){
                this.isEdit = false;
                this.isUploadDisable = false;
            },
            submitForm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        api.editSystemInfo(this.formSystemData).then(res => {
                            this.success(this.$t('m.editSuccess'));
                            this.isEdit = true;
                            this.updateSystemInfo();
                        })
                    }
                })
            },


            delImg() {
                if (this.isEdit) return;
                this.formSystemData.logo = null;
            },
            uploadSuccess(res, file) {
                if (res.result) {
                    this.formSystemData.logo = res.url;
                } else {
                    this.$message.error(res.message);
                }
            },
            beforeUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isLt2M) {
                    this.$message.error(this.$t('tip.imgUploadMaxSize', ['2']));
                } else {
                    this.imgUpload.params.access_token = Ticket.get().access_token
                }

                return isLt2M;
            },

            cancelCommit(formName){
                this.$refs[formName].resetFields();
                this.isEdit = true;
                this.updateSystemInfo();
            },
            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        watch: {
            /**
             * 如果应用首次加载，则在login或者app.vue中已经请求systemInfo了，
             * 因为是异步，所以需要watch，直到vuex中有此数据
             * 如果加载此页面时，vuex已经有数据，则直接加载数据
             */
            systemInfo(val) {
                this.fillSystemInfo(val);
            }
        },
        components: {
        }
    }
</script>

<style scoped lang="scss">
    .section {
        position: absolute;
        width: 800px;
        top: 18%;
        left: 50%;
        transform: translate(-50%, -10%);
        min-height: 430px;
        padding: 40px;
        border: 1px solid #d5d5d5;
        border-radius: 6px;
        background-color: #fff;
        overflow: hidden;
    }

    .info-wrap {
        display: flex;
        margin-top: 20px;
    }

    .system-form {
        width: 60%;

        .el-form-item {
            margin-bottom: 30px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .right-logo {
        width: 40%;

        .logo-txt {
            margin-top: 10px;
            text-align: center;
        }

        .logo-box {
            margin-top: 10px;
            &.inactive {
                .avatar-uploader {
                    background-color: #f5f7fa;
                    cursor: not-allowed;
                }
                /deep/.el-upload {
                    cursor: not-allowed;
                }
            }

            .avatar-uploader {
                position: relative;
                width: 220px;
                height: 220px;
                margin: 0 auto;
                border: 1px solid #ddd;
                background-color: #fff;
            }

            /deep/.el-upload {
                width: 100%;
                height: 100%;
                line-height: 220px;
                text-align: center;
            }

            .avatar {
                max-width: 90%;
                max-height: 90%;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                text-align: center;
            }

            .mask {
                position: absolute;
                left: 0;
                bottom: 0;
                right: 0;
                background-color: #000;
                opacity: 0.6;
                transition: all .3s ease-in-out;
                text-align: right;
                padding-right: 20px;
                color: #fff;
                height: 40px;
                line-height: 40px;
                cursor: default;
                .delete-cover {
                    display: inline-block;
                    font-size: 18px;
                    cursor: pointer;
                    &:hover {
                        transform: scale(1.1);
                    }
                }

            }
            .el-upload__tip {
                margin-top: -5px;
            }
        }
    }

    .operate_edit {
        position: absolute;
        right: 40px;
        margin-top: -15px;
        color: #a3a4a9;
        font-size: 22px;
        cursor: pointer;
        z-index: 1;
        &:hover {
            color: #22B9FF;
        }
    }


</style>
